import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { DialogModal } from '../../modal/common/DialogModal';

export const SimilarRacesModal = ({similarRaces, name, city, date, t}) => {
  const modalH1 = { fontSize: 25,
    float: 'left',
    width: '100%',
    color: '#4a4a4a',
    fontFamily: 'ProximaNovaRegular'};

  return (
    <DialogModal
      title={<h1 style={modalH1} id={'similar-race-modal-header'}>{t('Stop! Is this race already in our Calendar?')}</h1>}
      separator={false}
      body={
        <div style={{paddingLeft: '30px',color: '#9b9b9b',fontSize: '15px',fontFamily: 'ProximaNovaRegular'}}>
          <h4>{t('Stop! Is this race already in our Calendar?')}</h4>
          <div>
            <div>{t('The race listed below is already in our calendar.')}</div>
            <div>{t('If it is the race that you are trying to add, please select it to continue.')}</div>
          </div>
          {buildSimilarRacesList({name, city, date, similarRaces, t})}
        </div>
      }
    />
  );
};

function buildSimilarRacesList({similarRaces, city, date, name, t}) {
  //TODO the 'Pick' race link doesn't work
  return (
    <div>
      {
        (similarRaces || []).map((raceId) => {
          return (
            <div key={'race_'+raceId}>
              <span>
                <Link style={{display:'inline-block', marginRight:20, color: '#33aade', fontSize: '15px', fontFamily: 'ProximaNovaRegular'}}
                      to={`/race/event?raceid=${raceId}`}>
                  {t('Pick')}
                </Link>
              </span>
              <Link style={{color: '#33aade', fontSize: '15px', fontFamily: 'ProximaNovaRegular'}} to={`/race/event?raceid=${raceId}`} >
                {name}
              </Link>
              <div>
                {moment(date).format('MM/DD/YYYY') + '\u00A0\u2014\u00A0' + city}
              </div>
            </div>
          );
        })
      }
    </div>
  );
}





/** WEBPACK FOOTER **
 ** ./components/race/create/SimilarRacesModal.js
 **/